import type { ScreenSummary } from '@codot/contracts';
import { type Connection, connectionOf } from '../stores/presence';

/** A player's connection status, as every list and panel shows it. */
export type PlayerStatus = 'online' | 'reconnecting' | 'offline' | 'never' | 'unpaired';

export function playerStatus(s: Pick<ScreenSummary, 'id' | 'device' | 'lastSeenAt'>, now?: number): PlayerStatus {
  if (!s.device) return 'unpaired';
  if (!s.lastSeenAt) return 'never';
  return connectionOf(s.id, s.lastSeenAt, now);
}

/** Dot colour and label key (players.st…) per status. */
export const PLAYER_STATUS: Record<PlayerStatus, { dot: string; key: string }> = {
  online: { dot: 'bg-emerald-500', key: 'players.stOnline' },
  reconnecting: { dot: 'bg-amber-500 animate-pulse', key: 'players.stReconnecting' },
  offline: { dot: 'bg-red-500', key: 'players.stOffline' },
  never: { dot: 'bg-amber-400', key: 'players.stNever' },
  unpaired: { dot: 'bg-slate-400', key: 'players.stUnpaired' },
};

/** Just the connection (panels that list players already known to be paired): dot colour and label key. */
export const CONN_DOT: Record<Connection, string> = { online: 'bg-emerald-500', reconnecting: 'bg-amber-500 animate-pulse', offline: 'bg-slate-300 dark:bg-slate-600' };
export const CONN_KEY: Record<Connection, string> = { online: 'players.stOnline', reconnecting: 'players.stReconnecting', offline: 'players.stOffline' };
